import * as tslib_1 from "tslib";
import mailGroupFilesRouteHandler from './mailGroupFilesRouteHandler';
import { mailSxSCleanupRouteHandler } from './mailSxSRouteHandler';
import { lazyResetSxSViewStoreAction } from 'owa-group-files-hub-store';
export function mailGroupFilesSPCleanupRouteHandler(oldRoute, oldParameters, newRoute, newParameters) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, lazyResetSxSViewStoreAction.importAndExecute('browserNavigation')];
                case 1:
                    _a.sent();
                    return [2 /*return*/, false];
            }
        });
    });
}
export function mailGroupFilesSxSCleanupRouteHandler() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            return [2 /*return*/, mailSxSCleanupRouteHandler()];
        });
    });
}
export function mailGroupFilesSXSNavigationRouteHandler(parameters) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, mailGroupFilesRouteHandler(parameters, undefined)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=mailGroupFilesFilePreviewRouteHandlers.js.map